module.exports = __webpack_public_path__ + "img/1476388164.b15fb297.jpg";